import React from 'react';
import { Form } from 'react-bootstrap';

const CharacterCounter = ({ currentValue = '', maxLength = 250 }) => {
    const currentLength = currentValue?.length ?? 0;
    const remaining = Math.max(maxLength - currentLength, 0);

    return (
        <Form.Text className={`d-block w-100 text-muted`}>
            {remaining === 0
                ? '0 characters remaining'
                : `${remaining}/${maxLength} characters`}
        </Form.Text>
    );
};

export default CharacterCounter;
